<template>
  <div>
    <div class="row">
      <b-button variant="outline-secondary secondary-border-light"
                class="mr-2" @click="$bvModal.show('form');">
					        <span class="d-flex">
						        <i class="ri-add-line mr-1"></i>
					            {{ $t('new').toUpper() }}
					        </span>
      </b-button>
    </div>
    <div class="row" v-if="data">
      <b-table
          v-if="data.length>0"
          bordered
          striped
          responsive
          :items="data"
          :fields="fields"
          show-empty
          class="mb-5 table-dropdown no-scrollbar border rounded">
        <template #cell(dropdownTable)="row">
          <div class="d-flex">
            <b-button class="text-danger" variant="link" size="xs"
                      @click="del(row.item.id)">
              {{ $t('delete') | toUpperCase }}
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <CommonModal id="form" size="lg">
      <template v-slot:CommonModalTitle>
        <div>{{ $t('new_vinov_instruction').toUpper() }}</div>
      </template>
      <template v-slot:CommonModalContent>
        <ValidationObserver ref="form">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <ValidationProvider name="period_id" rules="required"
                                  v-slot="{valid, errors}">
                <b-form-group>
                  <label class="col-form-label pt-0">{{ $t('period') }}</label>
                  <payment-periods-selectbox ref="period_id"
                                             :validate-error="errors[0]"
                                             v-model="form.period_id"></payment-periods-selectbox>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4"
                 v-if="certificateApplications && certificateApplications.length">
              <ValidationProvider name="certificate_application_id" rules="required"
                                  v-slot="{valid, errors}">
                <b-form-group>
                  <label class="col-form-label pt-0">{{ $t('certificate') }}</label>
                  <multi-selectbox :multiple="false" ref="certificate" :options="computedCertificateApplications"
                                   :validate-error="errors[0]"
                                   v-model="form.certificate_application_id"></multi-selectbox>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <ValidationProvider name="amount" rules="required"
                                  v-slot="{valid, errors}">
                <b-form-group>
                  <label class="col-form-label pt-0">{{ $t('amount') }}</label>
                  <b-form-input
                      type="number"
                      step=".01"
                      v-model="form.amount"></b-form-input>
                  <b-form-invalid-feedback v-if="errors[0]"
                                           v-html="errors[0]"></b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <ValidationProvider name="currency" rules="required"
                                  v-slot="{valid, errors}">
                <b-form-group>
                  <label class="col-form-label pt-0">{{ $t('currency') }}</label>
                  <currency-selectbox
                      :validateError="errors[0]"
                      v-model="form.currency">
                  </currency-selectbox>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <ValidationProvider name="number_of_installments" rules=""
                                  v-slot="{valid, errors}">
                <b-form-group>
                  <label class="col-form-label pt-0">{{ $t('number_of_installments') }}</label>
                  <b-form-input
                      type="number" step="1"
                      v-model="form.number_of_installments"></b-form-input>
                  <b-form-invalid-feedback v-if="errors[0]"
                                           v-html="errors[0]"></b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12 col-sm-6 col-md-4 col-lg-4">
              <ValidationProvider name="down_payment_rate" rules="required"
                                  v-slot="{valid, errors}">
                <b-form-group>
                  <label class="col-form-label pt-0">{{ $t('down_payment_rate') }}</label>
                  <b-form-input
                      type="number" min="0" max="100"
                      v-model="form.down_payment_rate"></b-form-input>
                  <b-form-invalid-feedback v-if="errors[0]"
                                           v-html="errors[0]"></b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-md-4 col-sm-6">
              <ValidationProvider name="guardian_national_id" rules="required" v-slot="{valid, errors}">
                <b-form-group :label="$t('guardian_national_id')">
                  <b-form-input
                      v-model="form.guardian_national_id"
                      v-mask="'###########'"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="errors[0]"
                                           v-html="errors[0]"></b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-md-4 col-sm-6">
              <ValidationProvider name="guardian_mobile_tel" rules="required" v-slot="{valid, errors}">
                <b-form-group :label="$t('guardian_mobile_tel')">
                  <b-form-input
                      v-model="form.guardian_mobile_tel"
                      v-mask="'(5##) ### ## ##'"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="errors[0]"
                                           v-html="errors[0]"></b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </div>

            <div class="col-12">
              <b-button type="submit" @click="save" variant="primary">{{
                  $t('save')
                }}
              </b-button>
            </div>

          </div>
        </ValidationObserver>
      </template>
    </CommonModal>
  </div>
</template>

<script>
//Service
import VinovInstructionService from "@/services/VinovInstructionService";
//Component
import qs from "qs";
import PaymentPeriodsSelectbox from "@/components/interactive-fields/PaymentPeriodsSelectbox.vue";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";

export default {
  components: {
    CurrencySelectbox, MultiSelectbox, PaymentPeriodsSelectbox
  },
  props: {
    customer_id: {
      default: null
    },
    student_program_id: {
      default: null
    },
    registration_id: {
      default: null
    },
    certificate_application_id: {
      default: null
    },
    paymentPlans: null,
    certificateApplications: null
  },
  data() {
    return {
      fields: [
        {
          label: this.toUpperCase('id'),
          field: 'id',
        },
        {
          label: this.toUpperCase('student_number'),
          key: 'number',
          sortable: false
        },
        {
          label: this.toUpperCase('name'),
          key: 'name',
          sortable: false
        },
        {
          label: this.toUpperCase('surname'),
          key: 'surname',
          sortable: false
        },
        {
          label: this.toUpperCase('period'),
          key: 'period_code',
          sortable: false
        },
        {
          label: this.toUpperCase('amount'),
          key: 'amount',
          sortable: false
        },
        {
          label: this.toUpperCase('number_of_installments'),
          key: 'number_of_installments',
          sortable: false
        },
        {
          label: this.toUpperCase('guardian_national_id'),
          key: 'guardian_national_id',
          sortable: false
        },
        {
          label: this.toUpperCase('status'),
          key: 'status',
          sortable: false
        },
        {
          key: 'created_at',
          label: this.toUpperCase('created_at')
        },
        {key: 'dropdownTable', label: '#'}
      ],
      data: null,
      form: {}
    }
  },
  computed: {
    computedCertificateApplications() {
      if (!this.certificateApplications) {
        return [];
      }
      return this.certificateApplications.filter(item => {
        return item.balance > 0;
      }).map(item => {
        return {value: item.id, text: item.certificate.name};
      });
    }
  },
  methods: {
    loadData() {
      const config = {
        params: {
          filter: {customer_id: this.customer_id},
          limit: -1,
        },
        paramsSerializer: (params) => qs.stringify(params, {encode: false}),
      };
      VinovInstructionService.getAll(config).then(response => {
        this.data = response.data.data;
      }).catch(e => {
        this.showErrors(e);
      });
    },
    del(id) {
      if (id > 0) {
        this.$swal.fire({
          text: this.$t('are_you_sure_to_delete'),
          showCancelButton: true,
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        })
            .then((result) => {
              if (result.isConfirmed) {
                VinovInstructionService.del(id)
                    .then(response => {
                      this.toast(response.data);
                      this.loadData();
                    })
                    .catch(e => {
                      this.showErrors(e);
                    })
              }
            })

      }
    },
    async save() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        let formData = {...this.form};
        formData.customer_id = this.customer_id;
        formData.student_program_id = this.student_program_id;
        formData.registration_id = this.registration_id;
        VinovInstructionService.store(formData)
            .then(response => {
              this.$bvModal.hide('form');
              this.loadData();
            }).catch(e => {
          this.showErrors(e, this.$refs.form);
        });
      }
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    'form.period_id'(newVal) {
      if(!this.paymentPlans || !this.paymentPlans.length){
        return;
      }

      let periodItem = this.$refs.period_id.getItem(newVal);
      let paymentPlan = this.paymentPlans[periodItem.text];
      if (!paymentPlan) {
        return;
      }
      this.$set(this.form, 'amount', paymentPlan[0].price);
      this.$set(this.form, 'currency', paymentPlan[0].currency);
      this.$set(this.form, 'number_of_installments', paymentPlan[0].number_of_installments);
    },
    'form.certificate_application_id'(newVal) {
      let certificateItem = this.certificateApplications.find(item => item.id === newVal);
      this.$set(this.form, 'amount', certificateItem.balance);
      this.$set(this.form, 'currency', certificateItem.currency);
    }
  }
}
</script>
